import { render, staticRenderFns } from "./AgentsNewBreadcrumbButton.component.vue?vue&type=template&id=7074c0fd&scoped=true&"
import script from "./AgentsNewBreadcrumbButton.component.vue?vue&type=script&lang=js&"
export * from "./AgentsNewBreadcrumbButton.component.vue?vue&type=script&lang=js&"
import style0 from "./AgentsNewBreadcrumbButton.component.vue?vue&type=style&index=0&id=7074c0fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074c0fd",
  null
  
)

export default component.exports